import { Component, EventEmitter, Input, Type } from "@angular/core";


export enum TypeOfColumn { TEXT, DATE, COMPONENT, CURRENCY, DETAIL, NUMBER }

export interface TableColumnInfo {
  columnNameDef: string;
  
  label: string;
  labelOnOneLine?: boolean;

  sortable?: boolean;
  cellClass?: (row: any) => string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;

  type: TypeOfColumn;
  component?: Type<any>
}

// Classe da estendere per i componenti da usare nelle colonne
@Component({ template: '' })
export class ListPageColumnComponent {

    @Input() itemData?: any
    @Input() infoColumn?: TableColumnInfo;

    @Input() _reloadData: EventEmitter<any>;

    // Metodo usato per triggerare il reload della lista
    reloadData() {
        this._reloadData.emit()
    }
}
